// material-ui
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// project imports
import MainCard from "components/MainCard";

// types
import { GenericCardProps } from "types/root";

interface EcommerceMetrixProps extends GenericCardProps {}

// ==============================|| MATRIX CARD ||============================== //

export default function EcommerceMetrix({
  primary,
  secondary,
  content,
  iconPrimary,
  color,
}: EcommerceMetrixProps) {
  const IconPrimary = iconPrimary!;
  const primaryIcon = iconPrimary ? <IconPrimary fontSize="small" /> : null;

  return (
    <MainCard
      content={false}
      sx={{
        bgcolor: color,
        position: "relative",
        "&:before, &:after": {
          content: '""',
          width: 1,
          height: 1,
          position: "absolute",
          background:
            "linear-gradient(90deg, rgba(255, 255, 255, 0.0001) 22.07%, rgba(255, 255, 255, 0.15) 83.21%)",
          transform: "matrix(0.9, 0.44, -0.44, 0.9, 0, 0)",
        },
        "&:after": {
          top: "50%",
          right: "-20px",
        },
        "&:before": {
          right: "-70px",
          bottom: "80%",
        },
      }}
    >
      <Box sx={{ px: { xs: 3, sm: 3, md: 3, lg: 2 }, py: 4 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography
              sx={{
                color: "#fff",
                opacity: 0.23,
                fontSize: { xs: 40, sm: 35, md: 25, lg: 22, xl: 22 },
                lineHeight: 0,
              }}
            >
              {primaryIcon}
            </Typography>
          </Grid>
          <Grid item>
            <Stack spacing={1} alignItems="flex-end">
              <Typography
                color="common.white"
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: 30, sm: 25, md: 24, lg: 15, xl: 17 },
                }}
              >
                {primary}
              </Typography>
              <Typography
                color="common.white"
                sx={{ fontSize: { xs: 28, sm: 25, md: 23, lg: 15, xl: 16 } }}
              >
                {secondary}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
        <Stack
          spacing={1}
          direction="row"
          justifyContent="flex-end"
          sx={{ pt: 2.25 }}
        >
          <Typography
            variant="h5"
            color="common.white"
            sx={{ fontWeight: 400 }}
          >
            {content}
          </Typography>
        </Stack>
      </Box>
    </MainCard>
  );
}
